function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    externalResourcesRequired: "true"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    className: "bg-transparent w-screen max-w-full aspect-square md:w-[350px] md:h-[350px] lg:w-[400px] lg:h-[400px] xl:w-[600px] xl:h-[600px]",
    style: {
      accentColor: "auto",
      placeContent: "normal",
      placeItems: "normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      animationComposition: "replace",
      animation: "0s ease 0s 1 normal none running none",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box transparent",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: 600,
      borderBlockEnd: "0px solid rgb(229, 231, 235)",
      borderBlockStart: "0px solid rgb(229, 231, 235)",
      borderColor: "rgb(229, 231, 235)",
      borderRadius: 0,
      borderStyle: "solid",
      borderWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImage: "none 100% / 1 / 0 stretch",
      borderInlineEnd: "0px solid rgb(229, 231, 235)",
      borderInlineStart: "0px solid rgb(229, 231, 235)",
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      inset: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgba(48, 48, 48, 0.8)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgba(48, 48, 48, 0.8)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto",
      gap: "normal",
      columnRule: "0px rgba(48, 48, 48, 0.8)",
      columnSpan: "none",
      containIntrinsicBlockSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicInlineSize: "none",
      container: "none",
      content: "normal",
      cursor: "auto",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "block",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "__Space_Grotesk_587f35, __Space_Grotesk_Fallback_587f35",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: "15.9px",
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesis: "weight style small-caps",
      fontVariant: "normal",
      fontWeight: 400,
      grid: "none",
      gridArea: "auto",
      height: 600,
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: 600,
      insetArea: "none",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      mask: "none",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "100%",
      maxWidth: "100%",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offset: "normal",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgba(48, 48, 48, 0.8) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflow: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 45,
      padding: 45,
      paddingInline: 45,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "300px 300px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionTry: "none",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      rotate: "none",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      scrollTimeline: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 4,
      tableLayout: "auto",
      textAlign: "start",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgba(48, 48, 48, 0.8)",
      textDecorationSkipInk: "auto",
      textEmphasis: "none rgba(48, 48, 48, 0.8)",
      textEmphasisPosition: "over",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      whiteSpace: "normal",
      timelineScope: "none",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "300px 300px",
      transformStyle: "flat",
      transition: "all",
      translate: "none",
      unicodeBidi: "isolate",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimeline: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      widows: 2,
      width: 600,
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgba(48, 48, 48, 0.8)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgba(48, 48, 48, 0.8)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgb(0, 0, 0)",
      borderRadius: 0,
      accentColor: "auto",
      placeContent: "normal center",
      placeItems: "center normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      animationComposition: "replace",
      animation: "0s ease 0s 1 normal none running none",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: 510,
      borderBlockEnd: "0px solid rgb(229, 231, 235)",
      borderBlockStart: "0px solid rgb(229, 231, 235)",
      borderColor: "rgb(229, 231, 235)",
      borderStyle: "solid",
      borderWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImage: "none 100% / 1 / 0 stretch",
      borderInlineEnd: "0px solid rgb(229, 231, 235)",
      borderInlineStart: "0px solid rgb(229, 231, 235)",
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      inset: "auto",
      boxShadow: "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgba(48, 48, 48, 0.8)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgba(48, 48, 48, 0.8)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto",
      gap: "normal",
      columnRule: "0px rgba(48, 48, 48, 0.8)",
      columnSpan: "none",
      containIntrinsicBlockSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicInlineSize: "none",
      container: "none",
      content: "normal",
      cursor: "auto",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "flex",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "__Space_Grotesk_587f35, __Space_Grotesk_Fallback_587f35",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: "15.9px",
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesis: "weight style small-caps",
      fontVariant: "normal",
      fontWeight: 400,
      grid: "none",
      gridArea: "auto",
      height: 510,
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: 510,
      insetArea: "none",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      mask: "none",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offset: "normal",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgba(48, 48, 48, 0.8) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflow: "hidden",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "255px 255px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionTry: "none",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      rotate: "none",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      scrollTimeline: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 4,
      tableLayout: "auto",
      textAlign: "start",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgba(48, 48, 48, 0.8)",
      textDecorationSkipInk: "auto",
      textEmphasis: "none rgba(48, 48, 48, 0.8)",
      textEmphasisPosition: "over",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      whiteSpace: "normal",
      timelineScope: "none",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "255px 255px",
      transformStyle: "flat",
      transition: "all",
      translate: "none",
      unicodeBidi: "isolate",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimeline: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      widows: 2,
      width: 510,
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgba(48, 48, 48, 0.8)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgba(48, 48, 48, 0.8)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    },
    className: "w-full aspect-square overflow-hidden flex justify-center items-center shadow-none"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      transform: "matrix(1, 0, 0, 1, 0, 0)",
      accentColor: "auto",
      placeContent: "normal",
      placeItems: "normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      animationComposition: "replace",
      animation: "0s ease 0s 1 normal none running none",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0)",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: 400,
      borderBlockEnd: "0px solid rgb(229, 231, 235)",
      borderBlockStart: "0px solid rgb(229, 231, 235)",
      borderColor: "rgb(229, 231, 235)",
      borderRadius: 0,
      borderStyle: "solid",
      borderWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImage: "none 100% / 1 / 0 stretch",
      borderInlineEnd: "0px solid rgb(229, 231, 235)",
      borderInlineStart: "0px solid rgb(229, 231, 235)",
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      inset: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgba(48, 48, 48, 0.8)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgba(48, 48, 48, 0.8)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto",
      gap: "normal",
      columnRule: "0px rgba(48, 48, 48, 0.8)",
      columnSpan: "none",
      containIntrinsicBlockSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicInlineSize: "none",
      container: "none",
      content: "normal",
      cursor: "auto",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "block",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "__Space_Grotesk_587f35, __Space_Grotesk_Fallback_587f35",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: "15.9px",
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesis: "weight style small-caps",
      fontVariant: "normal",
      fontWeight: 400,
      grid: "none",
      gridArea: "auto",
      height: 400,
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: 400,
      insetArea: "none",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      mask: "none",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: "auto",
      minHeight: "auto",
      minInlineSize: "auto",
      minWidth: "auto",
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offset: "normal",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgba(48, 48, 48, 0.8) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflow: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "200px 200px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionTry: "none",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      rotate: "none",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      scrollTimeline: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 4,
      tableLayout: "auto",
      textAlign: "start",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgba(48, 48, 48, 0.8)",
      textDecorationSkipInk: "auto",
      textEmphasis: "none rgba(48, 48, 48, 0.8)",
      textEmphasisPosition: "over",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      whiteSpace: "normal",
      timelineScope: "none",
      touchAction: "auto",
      transformOrigin: "200px 200px",
      transformStyle: "flat",
      transition: "all",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimeline: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      widows: 2,
      width: 400,
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgba(48, 48, 48, 0.8)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgba(48, 48, 48, 0.8)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    viewBox: "0 0 24 24",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-blocks",
    fillOpacity: 0,
    style: {
      accentColor: "auto",
      placeContent: "normal",
      placeItems: "normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      animationComposition: "replace",
      animation: "0s ease 0s 1 normal none running none",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0)",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: 400,
      borderBlockEnd: "0px solid rgb(229, 231, 235)",
      borderBlockStart: "0px solid rgb(229, 231, 235)",
      borderColor: "rgb(229, 231, 235)",
      borderRadius: 0,
      borderStyle: "solid",
      borderWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImage: "none 100% / 1 / 0 stretch",
      borderInlineEnd: "0px solid rgb(229, 231, 235)",
      borderInlineStart: "0px solid rgb(229, 231, 235)",
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      inset: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgba(48, 48, 48, 0.8)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgba(48, 48, 48, 0.8)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto",
      gap: "normal",
      columnRule: "0px rgba(48, 48, 48, 0.8)",
      columnSpan: "none",
      containIntrinsicBlockSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicInlineSize: "none",
      container: "none",
      content: "normal",
      cursor: "auto",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "block",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(255, 255, 255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "__Space_Grotesk_587f35, __Space_Grotesk_Fallback_587f35",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: "15.9px",
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesis: "weight style small-caps",
      fontVariant: "normal",
      fontWeight: 400,
      grid: "none",
      gridArea: "auto",
      height: 400,
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: 400,
      insetArea: "none",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      mask: "none",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offset: "normal",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgba(48, 48, 48, 0.8) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowClipMargin: "content-box",
      overflowWrap: "normal",
      overflow: "hidden",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "200px 200px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionTry: "none",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      rotate: "none",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      scrollTimeline: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "rgb(255, 255, 255)",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 2,
      tabSize: 4,
      tableLayout: "auto",
      textAlign: "start",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgba(48, 48, 48, 0.8)",
      textDecorationSkipInk: "auto",
      textEmphasis: "none rgba(48, 48, 48, 0.8)",
      textEmphasisPosition: "over",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      whiteSpace: "normal",
      timelineScope: "none",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "200px 200px",
      transformStyle: "flat",
      transition: "all",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "middle",
      viewTimeline: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      widows: 2,
      width: 400,
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgba(48, 48, 48, 0.8)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgba(48, 48, 48, 0.8)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    x: 14,
    y: 3,
    rx: 1,
    style: {
      accentColor: "auto",
      placeContent: "normal",
      placeItems: "normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      animationComposition: "replace",
      animation: "0s ease 0s 1 normal none running none",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0)",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: 7,
      borderBlockEnd: "0px solid rgb(229, 231, 235)",
      borderBlockStart: "0px solid rgb(229, 231, 235)",
      borderColor: "rgb(229, 231, 235)",
      borderRadius: 0,
      borderStyle: "solid",
      borderWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImage: "none 100% / 1 / 0 stretch",
      borderInlineEnd: "0px solid rgb(229, 231, 235)",
      borderInlineStart: "0px solid rgb(229, 231, 235)",
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      inset: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgba(48, 48, 48, 0.8)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgba(48, 48, 48, 0.8)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto",
      gap: "normal",
      columnRule: "0px rgba(48, 48, 48, 0.8)",
      columnSpan: "none",
      containIntrinsicBlockSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicInlineSize: "none",
      container: "none",
      content: "normal",
      cursor: "auto",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(255, 255, 255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "__Space_Grotesk_587f35, __Space_Grotesk_Fallback_587f35",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: "15.9px",
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesis: "weight style small-caps",
      fontVariant: "normal",
      fontWeight: 400,
      grid: "none",
      gridArea: "auto",
      height: 7,
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: 7,
      insetArea: "none",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      mask: "none",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offset: "normal",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgba(48, 48, 48, 0.8) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflow: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionTry: "none",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      rotate: "none",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: 1,
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      scrollTimeline: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "rgb(255, 255, 255)",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 2,
      tabSize: 4,
      tableLayout: "auto",
      textAlign: "start",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgba(48, 48, 48, 0.8)",
      textDecorationSkipInk: "auto",
      textEmphasis: "none rgba(48, 48, 48, 0.8)",
      textEmphasisPosition: "over",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      whiteSpace: "normal",
      timelineScope: "none",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transition: "all",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimeline: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      widows: 2,
      width: 7,
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 14,
      y: 3,
      zIndex: "auto",
      zoom: 1,
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgba(48, 48, 48, 0.8)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgba(48, 48, 48, 0.8)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 21V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H3",
    style: {
      accentColor: "auto",
      placeContent: "normal",
      placeItems: "normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      anchorName: "none",
      animationComposition: "replace",
      animation: "0s ease 0s 1 normal none running none",
      appRegion: "none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0)",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      baselineSource: "auto",
      blockSize: "auto",
      borderBlockEnd: "0px solid rgb(229, 231, 235)",
      borderBlockStart: "0px solid rgb(229, 231, 235)",
      borderColor: "rgb(229, 231, 235)",
      borderRadius: 0,
      borderStyle: "solid",
      borderWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImage: "none 100% / 1 / 0 stretch",
      borderInlineEnd: "0px solid rgb(229, 231, 235)",
      borderInlineStart: "0px solid rgb(229, 231, 235)",
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      inset: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgba(48, 48, 48, 0.8)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgba(48, 48, 48, 0.8)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto",
      gap: "normal",
      columnRule: "0px rgba(48, 48, 48, 0.8)",
      columnSpan: "none",
      containIntrinsicBlockSize: "none",
      containIntrinsicSize: "none",
      containIntrinsicInlineSize: "none",
      container: "none",
      content: "normal",
      cursor: "auto",
      cx: 0,
      cy: 0,
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fieldSizing: "fixed",
      fill: "rgb(255, 255, 255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "__Space_Grotesk_587f35, __Space_Grotesk_Fallback_587f35",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontPalette: "normal",
      fontSize: "15.9px",
      fontSizeAdjust: "none",
      fontStretch: "100%",
      fontStyle: "normal",
      fontSynthesis: "weight style small-caps",
      fontVariant: "normal",
      fontWeight: 400,
      grid: "none",
      gridArea: "auto",
      height: "auto",
      hyphenateCharacter: "auto",
      hyphenateLimitChars: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      initialLetter: "normal",
      inlineSize: "auto",
      insetArea: "none",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      mask: "none",
      maskType: "luminance",
      mathDepth: 0,
      mathShift: "normal",
      mathStyle: "normal",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      objectViewBox: "none",
      offset: "normal",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgba(48, 48, 48, 0.8) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflow: "visible",
      overlay: "none",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      positionAnchor: "auto",
      positionTry: "none",
      positionVisibility: "always",
      r: 0,
      resize: "none",
      rotate: "none",
      rubyAlign: "space-around",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scale: "none",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      scrollTimeline: "none",
      scrollbarColor: "auto",
      scrollbarGutter: "auto",
      scrollbarWidth: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "rgb(255, 255, 255)",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 2,
      tabSize: 4,
      tableLayout: "auto",
      textAlign: "start",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgba(48, 48, 48, 0.8)",
      textDecorationSkipInk: "auto",
      textEmphasis: "none rgba(48, 48, 48, 0.8)",
      textEmphasisPosition: "over",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textSpacingTrim: "normal",
      textTransform: "none",
      textUnderlinePosition: "auto",
      whiteSpace: "normal",
      timelineScope: "none",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transition: "all",
      translate: "none",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      viewTimeline: "none",
      viewTransitionClass: "none",
      viewTransitionName: "none",
      visibility: "visible",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextFillColor: "rgba(48, 48, 48, 0.8)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgba(48, 48, 48, 0.8)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6782913d69c9ee0927e9f0908e8bb2df.svg";
export { ForwardRef as ReactComponent };